import WarrantiesList from './WarrantiesList'

export default {
    WarrantiesList
}
